// 处方路由
export default [
    {
        path: "/other/contact",
        name: "otherContact",
        component: () => import("@/views/other/contact")
    },
    // 老版本迁移--联系客服
    {
        path: "/customerService",
        name: "customerService",
        component: () => import("@/views/other/contact")
    },
    {
        path: "/zhuisu",
        name: "zhuisu",
        component: () => import("@/views/other/yaopinzhuisu")
    }
];



// WEBPACK FOOTER //
// ./src/router/other.js